import React, { useEffect, useState } from 'react';
import { Form } from 'reactstrap';
import { Box, Modal, Typography, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import SaveIcon from '@material-ui/icons/Save';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from '@material-ui/core/Select';
import { styled } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import moment from 'moment';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 450,
  width: 800,
  bgcolor: 'background.paper',
  border: '1px solid #59b9ea',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
    color: 'red',
  },
});

const CssTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: 'green',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});

function MaterialEdit(props) {
  const { addOrEdit } = props;
  const [materialSelectData, setMaterialSelectData] = useState([]); // 셀렉트 업체 자료 가져오기

  const [materialId] = useState(props.materialEditValue.Id); //구매자재 Id
  const [materialUpche, setMaterialUpche] = useState({
    label: props.materialEditValue.r_자재업체명,
    value: props.materialEditValue.r_자재업체코드,
    subul: props.materialEditValue.r_자재수불,
  }); // 셀렉트업체가져오기
  const [materialJajeCodeNo, setMaterialJajeCodeNo] = useState(props.materialEditValue.r_자재코드); //자재코드생성번호
  const [materialJajeItem, setMaterialJajeItem] = useState(
    props.materialEditValue.r_자재품번 === null ? '' : props.materialEditValue.r_자재품번
  ); //자재품번
  const [materialJajeStandader, setMaterialJajeStandader] = useState(props.materialEditValue.r_자재규격); //자재규격[품명]
  const [materialJajeQuantity, setMaterialJajeQuantity] = useState(
    props.materialEditValue.r_자재단위량 === 0 ? '' : props.materialEditValue.r_자재단위량
  ); //자재단위량
  const [materialJajeDanwi, setMaterialJajeDanwi] = useState(props.materialEditValue.r_자재단위); //자재단위
  const [materialJajeDanga, setMaterialJajeDanga] = useState(props.materialEditValue.r_자재단가); //자재단가
  const [materialJajeGejungSelectData, setMaterialJajeGejungSelectData] = useState([]); //계정과목셀렉트)
  const [materialJajeGejunghangmok, setMaterialJajeGejunghangmok] = useState({
    hangmokCode: props.materialEditValue.r_자재계정항목코드,
    hangmok: props.materialEditValue.r_자재계정항목,
    gamokCode: props.materialEditValue.r_자재계정과목코드,
    gamok: props.materialEditValue.r_자재계정과목,
  }); //계정과목가져오기
  const [materialJajeGubun, setMaterialJajeGubun] = useState(props.materialEditValue.r_자재구분); //자재구분
  const [materialJajeYesNo, setMaterialJajeYesNo] = useState(props.materialEditValue.r_자재사용유무); //업체자재사용유무
  const [materialJichulBulru, setMaterialJichulBulru] = useState(props.materialEditValue.r_자재지출분류); //업체자재지출분류

  // 생성자재코드번호
  let materialJajeCodeNoHandle = (e) => {
    e.preventDefault();
    setMaterialJajeCodeNo(e.target.value);
  };

  // 자재품번
  let materialJajeItemHandle = (e) => {
    e.preventDefault();
    setMaterialJajeItem(e.target.value);
  };

  //대표자성명
  let materialJajeStandaderHandle = (e) => {
    e.preventDefault();
    setMaterialJajeStandader(e.target.value);
  };
  //자재단위량
  let materialJajeQuantityHandle = (e) => {
    e.preventDefault();
    setMaterialJajeQuantity(e.target.value);
  };
  //자재단위
  let materialJajeDanwiHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanwi(e.target.value);
  };
  //자재단가
  let materialJajeDangaHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanga(e.target.value);
  };

  //자재구분
  let materialJajeGubunHandle = (e) => {
    e.preventDefault();
    setMaterialJajeGubun(e.target.value);
  };

  //자재사용유무
  let materialJajeYesNoHandle = (e) => {
    e.preventDefault();
    setMaterialJajeYesNo(e.target.value);
  };
  //자재지출분류
  let materialJichulBulruHandle = (e) => {
    e.preventDefault();
    setMaterialJichulBulru(e.target.value);
  };

  // 화면지우기
  let createClickHeandle = (e) => {
    setMaterialUpche({ label: '', value: '', subul: '' });
    setMaterialJajeItem(''); //자재품번
    setMaterialJajeStandader('');
    setMaterialJajeQuantity(''); //자재단위량
    setMaterialJajeDanwi(''); //자재단위
    setMaterialJajeDanga(''); //자재단가
    setMaterialJajeGejunghangmok({ hangmokCode: '', hangmok: '', gamokCode: '', gamok: '' }); //계정과목
    materialJajeGubun(''); //자재구분
    setMaterialJajeYesNo('Yes'); //자재사용유무
    setMaterialJichulBulru(''); //자재지출분류
  };

  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('Id', materialId);
    formData.append('r_자재업체코드', materialUpche.value);
    formData.append('r_자재업체명', materialUpche.label);
    formData.append('r_자재수불', materialUpche.subul);
    formData.append('r_자재코드', materialJajeCodeNo);
    formData.append('r_자재품번', materialJajeItem);
    formData.append('r_자재규격', materialJajeStandader);
    formData.append('r_자재단위량', materialJajeQuantity === null ? '' : materialJajeQuantity);
    formData.append('r_자재단위', materialJajeDanwi);
    formData.append('r_자재단가', materialJajeDanga);
    formData.append('r_자재계정항목코드', materialJajeGejunghangmok.hangmokCode);
    formData.append('r_자재계정항목', materialJajeGejunghangmok.hangmok);
    formData.append('r_자재계정과목코드', materialJajeGejunghangmok.gamokCode);
    formData.append('r_자재계정과목', materialJajeGejunghangmok.gamok);
    formData.append('r_자재구분', materialJajeGubun);
    formData.append('r_자재사용유무', materialJajeYesNo);
    formData.append('r_자재지출분류', materialJichulBulru);
    formData.append('r_등록일자', moment().format('YYYY-MM-DD HH:mm'));
    formData.append('r_등록자', props.urlpw);
    addOrEdit(formData);
    props.setMaterialEditModal(false);
  };

  //업체select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/').then((res) => {
      setMaterialSelectData(res.data);
    });
  }, []);

  //selectPicker 데이타뿌리기
  const selectData = materialSelectData.map((item) => ({
    label: item.s_업체상호,
    value: item.s_업체코드,
    subul: item.s_업무구분,
  }));

  //계정항목,계정과목 select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/MatrialsGejung/').then((res) => {
      setMaterialJajeGejungSelectData(res.data);
    });
  }, []);

  //selectPicker 데이타뿌리기
  const GejungSelectData = materialJajeGejungSelectData.map((item) => ({
    hangmokCode: item.r_계정항목코드,
    hangmok: item.r_계정항목,
    gamokCode: item.r_계정과목코드,
    gamok: item.r_계정과목,
  }));

  return (
    <div>
      <Modal open={props.materialEditModal}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: 'D2Coding',
                fontSize: '24px',
                color: 'green',
                textAlign: 'center',
              }}
            >
              구매자재수정
            </Typography>
          </div>

          <Form onSubmit={handleSubmit}>
            <div>
              <div>
                <Autocomplete
                  options={selectData}
                  getOptionLabel={(option) => (option.label ? option.label : '')}
                  size="small"
                  style={{ width: 200, marginRight: 3 }}
                  value={materialUpche ? materialUpche : { label: '', value: '', subul: '' }}
                  onChange={(event, newValue) => {
                    setMaterialUpche(newValue);
                  }}
                  renderInput={(params) => <CssTextField required {...params} label="업체" variant="outlined" />}
                />
              </div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialUpche === null ? { shrink: false } : { shrink: true }}
                  label="업체코드"
                  name="materialCodeNo"
                  size="small"
                  value={materialUpche === null ? '' : materialUpche.value}
                />
                <TextField
                  // disabled
                  required //필수등록
                  error
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialUpche === null ? { shrink: false } : { shrink: true }}
                  label="업체상호"
                  name="materialSangho"
                  size="small"
                  value={materialUpche === null ? '' : materialUpche.label}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialUpche === null ? { shrink: false } : { shrink: true }}
                  label="자재수불"
                  name="materialJajeSubul"
                  size="small"
                  value={materialUpche === null ? '' : materialUpche.subul}
                />
              </div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  onChange={materialJajeCodeNoHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeCodeNo === '' ? { shrink: false } : { shrink: true }}
                  id=""
                  label="자재코드"
                  name="materialJajeCodeNo"
                  size="small"
                  value={materialJajeCodeNo ? materialJajeCodeNo : ''}
                />
                <FormControl
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>지출분류</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJichulBulru}
                    onChange={materialJichulBulruHandle}
                    label="지출분류"
                  >
                    <MenuItem value="">
                      <div style={{ color: 'red' }}>지정없음</div>
                    </MenuItem>
                    <MenuItem value={'고정비용'}>고정비용</MenuItem>
                    <MenuItem value={'변동비용'}>변동비용</MenuItem>
                    <MenuItem value={'일반비용'}>일반비용</MenuItem>
                    <MenuItem value={'카드비용'}>카드비용</MenuItem>
                    <MenuItem value={'세액비용'}>세액비용</MenuItem>
                    <MenuItem value={'자동이체'}>자동이체</MenuItem>
                    <MenuItem value={'개인비용지출'}><div style={{ color: 'darkorange' }}>개인비용지출</div></MenuItem>
                    <MenuItem value={'퇴직통장지출'}><div style={{ color: 'darkorange' }}>퇴직통장지출</div></MenuItem>
                    <MenuItem value={'부가통장지출'}><div style={{ color: 'darkorange' }}>부가통장지출</div></MenuItem>
                    <MenuItem value={'대출통장지출'}><div style={{ color: 'darkorange' }}>대출통장지출</div></MenuItem>
                    {/* <MenuItem value={'기타비용'}><div style={{ color: 'blue' }}>기타비용</div></MenuItem> */}
                  </CssSelect>
                </FormControl>
              </div>
              <div>
                <CssTextField
                  // required //필수등록
                  onChange={materialJajeItemHandle}
                  style={{ width: 150, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeItem === '' ? { shrink: false } : { shrink: true }}
                  label="자재품번"
                  name="materialJajeItem"
                  size="small"
                  value={materialJajeItem ? materialJajeItem : ''}
                />
                <TextField
                  required //필수등록
                  error
                  onChange={materialJajeStandaderHandle}
                  style={{ width: 200, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeStandader === '' ? { shrink: false } : { shrink: true }}
                  label="자재규격[품명]"
                  name="materialJajeStandader"
                  size="small"
                  value={materialJajeStandader ? materialJajeStandader : ''}
                />
                <CssTextField
                  required //필수등록
                  // error
                  onChange={materialJajeQuantityHandle}
                  style={{ width: 130, marginTop: '8px', float: 'center', marginRight: '2px', textAlign: 'right' }}
                  variant="outlined"
                  InputLabelProps={materialJajeQuantity === '' ? { shrink: false } : { shrink: true }}
                  label="단위량[단위별]"
                  name="materialJajeQuantity"
                  size="small"
                  value={materialJajeQuantity ? materialJajeQuantity : ''}
                />
                <FormControl
                  required
                  // error
                  variant="outlined"
                  style={{ minWidth: 100, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>단위</InputLabel>
                  <CssSelect
                    required
                    variant="outlined"
                    value={materialJajeDanwi ? materialJajeDanwi : ''}
                    onChange={materialJajeDanwiHandle}
                    label="단위"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={'원'}>원</MenuItem>
                    <MenuItem value={'g'}>g</MenuItem>
                    <MenuItem value={'Kg'}>Kg</MenuItem>
                    <MenuItem value={'Ea'}>Ea[개]</MenuItem>
                    <MenuItem value={'Box'}>Box</MenuItem>
                    <MenuItem value={'Can'}>Can</MenuItem>
                    <MenuItem value={'㎖'}>㎖</MenuItem>
                    <MenuItem value={'ℓ'}>ℓ</MenuItem>
                    <MenuItem value={'갤런(gal)'}>갤런(gal)</MenuItem>
                    <MenuItem value={'말'}>말</MenuItem>
                    <MenuItem value={'포'}>포</MenuItem>
                    <MenuItem value={'드럼'}>드럼</MenuItem>
                    <MenuItem value={'mm'}>mm</MenuItem>
                    <MenuItem value={'Cm'}>Cm</MenuItem>
                    <MenuItem value={'m'}>m</MenuItem>
                    <MenuItem value={'P/L'}>P/L[파렛트]</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  required //필수등록
                  type="number"
                  onChange={materialJajeDangaHandle}
                  style={{ width: 150, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeDanga === '' ? { shrink: false } : { shrink: true }}
                  label="단가"
                  name="materialJajeDanga"
                  size="small"
                  value={materialJajeDanga ? Number(materialJajeDanga) : ''}
                />
              </div>
              <div>
                <Autocomplete
                  options={GejungSelectData}
                  getOptionLabel={(option) => (option.gamok ? option.gamok : '')}
                  size="small"
                  style={{ width: 200, marginTop: '8px', marginRight: 3 }}
                  value={
                    materialJajeGejunghangmok
                      ? materialJajeGejunghangmok
                      : { hangmokCode: '', hangmok: '', gamokCode: '', gamok: '' }
                  }
                  onChange={(event, newValue) => {
                    setMaterialJajeGejunghangmok(newValue);
                  }}
                  renderInput={(params) => (
                    <CssTextField required {...params} label="계정과목찾기" variant="outlined" />
                  )}
                />
              </div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeGejunghangmok === null ? { shrink: false } : { shrink: true }}
                  label="계정항목코드"
                  name="GejungSelectDataCode"
                  size="small"
                  value={materialJajeGejunghangmok === null ? '' : materialJajeGejunghangmok.hangmokCode}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeGejunghangmok === null ? { shrink: false } : { shrink: true }}
                  label="계정항목"
                  name="GejungSelectData"
                  size="small"
                  value={materialJajeGejunghangmok === null ? '' : materialJajeGejunghangmok.hangmok}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeGejunghangmok === null ? { shrink: false } : { shrink: true }}
                  label="계정과목코드"
                  name="GejungSelectData"
                  size="small"
                  value={materialJajeGejunghangmok === null ? '' : materialJajeGejunghangmok.gamokCode}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px' }}
                  variant="outlined"
                  InputLabelProps={materialJajeGejunghangmok === null ? { shrink: false } : { shrink: true }}
                  label="계정과목"
                  name="GejungSelectData"
                  size="small"
                  value={materialJajeGejunghangmok === null ? '' : materialJajeGejunghangmok.gamok}
                />
              </div>
              <div>
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>자재구분</InputLabel>
                  <CssSelect
                    required
                    variant="outlined"
                    value={materialJajeGubun ? materialJajeGubun : ''}
                    onChange={materialJajeGubunHandle}
                    label="자재구분"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={'피착'}>피착</MenuItem>
                    <MenuItem value={'피막'}>피막</MenuItem>
                    <MenuItem value={'착색'}>착색</MenuItem>
                    <MenuItem value={'접착'}>접착</MenuItem>
                    <MenuItem value={'에칭'}>에칭</MenuItem>
                    <MenuItem value={'공통'}>공통</MenuItem>
                    <MenuItem value={'기타'}>기타</MenuItem>
                  </CssSelect>
                </FormControl>
                <FormControl
                  variant="outlined"
                  style={{ minWidth: 120, marginTop: '8px', float: 'center', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>자재사용YesNo</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJajeYesNo}
                    onChange={materialJajeYesNoHandle}
                    label="자재사용YesNo"
                  >
                    {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                    <MenuItem value={'Yes'}>Yes</MenuItem>
                    <MenuItem value={'No'}>No</MenuItem>
                  </CssSelect>
                </FormControl>
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                // onClick={handleSubmit}
                type="submit"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{
                  height: '37px',
                  background: '#388e3c',
                  color: 'white',
                  width: 100,
                  marginRight: '2px',
                  float: 'center',
                }}
              >
                수정
              </Button>
              <Button
                onClick={createClickHeandle}
                variant="contained"
                startIcon={<SaveIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  marginRight: '2px',
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                지우기
              </Button>
              <Button
                onClick={() => {
                  props.setMaterialEditModal(false);
                }}
                variant="contained"
                startIcon={<SaveIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                나가기
              </Button>
              <strong style={{ marginLeft: '5px', color: 'red' }}>빨간색은 등록된 항목과 동일하면 안됩니다.</strong>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}

export default MaterialEdit;
